import Mock from '@/mocks/Mock'
import WeatherWarningHistory, { WeatherWarningHistoryAttrs } from '@/models/WeatherWarningHistory'
import { WeatherWarningHistoryParams } from '@/repositories/weather-warning-history-repository'

export default class WeatherWarningHistoryMock extends Mock<WeatherWarningHistoryAttrs> {
  constructor() {
    super('weather_waring_history')
  }

  get(params: WeatherWarningHistoryParams) {
    console.log(params)

    return new WeatherWarningHistory(this.data)
  }
}
